import { TextFieldWidget } from '@tableau/widgets';
import React from 'react';

import { Keys } from '~commonInfra/utils/Keys';
import { Messages } from '~src/codegen/Localize';

import { searchInput } from './FilterPanelStyles';



export interface SearchFieldProps {
  readonly searchText: string;
  readonly setSearchText: (searchText: string) => void;
  readonly submitSearch: (searchText: string, event?: React.KeyboardEvent<HTMLInputElement>) => void;
}

export function SearchField(props: SearchFieldProps) {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.setSearchText(e.target.value);
  };

  const handleClear = () => {
    props.setSearchText('');
    props.submitSearch('');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    switch (e.which) {
      case Keys.Enter:
        e.preventDefault();
        e.stopPropagation();
        props.submitSearch(props.searchText, e);
    }
  };

  const handleBlur = () => props.submitSearch(props.searchText);

  return <TextFieldWidget
    className={searchInput}
    kind='search'
    label={Messages.filterPanel_searchFilterLabel()}
    maxLength={200}
    onBlur={handleBlur}
    onChange={handleChange}
    onClear={handleClear}
    onKeyDown={handleKeyDown}
    placeholder={Messages.filterPanel_searchFilterPlaceholder()}
    style={{ width: '100%' }}
    testId='filter-search'
    value={props.searchText}
  />;
}
